import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import GovernmentServiceEditor from "../../editors/masterdata/governmentService";

const GovernmentServices: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.GovernmentServicesList}
			endpoint={Endpoint.GovernmentServices}
			addScreen={{ screen: GovernmentServiceEditor, isAllowed: hasPermission(Permission.GovernmentServicesAdd) }}
			editScreen={{ screen: GovernmentServiceEditor, isAllowed: hasPermission(Permission.GovernmentServicesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.GovernmentServicesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default GovernmentServices;
